const TITULO_LABELS: Record<string, string> = {
  plena_propiedad: 'Plena propiedad',
  nuda_propiedad: 'Nuda Propiedad',
  usufructo: 'Usufructo',
};

export function formatTituloLabel(titulo: string | null | undefined): string {
  if (!titulo?.trim()) return '-';
  const key = titulo.trim().toLowerCase();
  return TITULO_LABELS[key] ?? titulo;
}
